import { makeAutoObservable } from 'mobx'

import { WidgetApi } from '../api'

import { GlobalStore } from './GlobalStore'

export class ConnectStore {
  globalStore: GlobalStore
  widgetApi: WidgetApi = new WidgetApi('/', '')

  constructor(globalStore: GlobalStore) {
    this.globalStore = globalStore
    this.widgetApi = new WidgetApi(globalStore.endpoint, globalStore.sessionToken)

    makeAutoObservable(this)
  }

  loadWidget = async ({ widget = 'connect_widget', mode = 'light', ...rest }) => {
    return await this.widgetApi.requestWidgetUrl({
      widget_url: { widget_type: widget, color_scheme: mode, ...rest },
    })
  }
}
